<template>
  <div class="custom-main custom-theme" style="margin: 0px;">
    <a-layout class="ant-layout-body">
      <gpws-header/>
      <a-layout-content>
        <a-row>
          <a-col :xxl="2" :xl="2" :lg="2" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
          <a-col :xxl="20" :xl="20" :lg="20" :md="24" :sm="24" :xs="24">
            <a-card :bordered="false" :body-style="{'paddingTop':'12px'}">
              <a-row>
                <a-col span="16" style="padding-left:24px;padding-bottom: 10px;border-bottom: 1px solid #e8e8e8;">
                  <a-button-group shape="round">
                    <a-button size="default"
                              :class="(init.business =='A'?'gpws-business-left-active':'gpws-business-left-btn')"
                              @click="businessChecked('A')">我的辅诊预约
                    </a-button>
                    <a-button size="default" :class="(init.business =='B'?'gpws-business-active':'gpws-business-btn')"
                              @click="businessChecked('B')">我的远程审方
                    </a-button>
                    <a-button size="default" :class="(init.business =='C'?'gpws-business-active':'gpws-business-btn')"
                              @click="businessChecked('C')">远程辅诊记录
                    </a-button>
                    <a-button size="default"
                              :class="(init.business =='D'?'gpws-business-right-active':'gpws-business-right-btn')"
                              @click="businessChecked('D')">远程审方记录
                    </a-button>
                  </a-button-group>
                </a-col>
                <a-col span="8" style="padding-right:24px;padding-bottom: 10px;border-bottom: 1px solid #e8e8e8;">
                  <img src="../../../assets/img/refresh.png" v-if="init.business =='A'" style="float:right;cursor: pointer;user-select: none;margin: auto;" @click="refreshAction"/>
                </a-col>
              </a-row>
              <a-card :bordered="false" v-if="init.business == 'A'" style="margin-left: 6px;height:calc(100vh - 200px);"
                      :body-style="{'padding':'0px'}">
                <reserve-outpatient ref="reserve"/>
              </a-card>
              <a-card :bordered="false" v-if="init.business == 'B'" style="margin-left: 6px;height:calc(100vh - 200px);"
                      :body-style="{'padding':'0px'}">
                <examine-outpatient/>
              </a-card>
              <a-card :bordered="false" v-if="init.business == 'C'" style="margin-left: 6px;height:calc(100vh - 200px);"
                      :body-style="{'padding':'0px'}">
                <telemed-outpatient/>
              </a-card>
              <a-card :bordered="false" v-if="init.business == 'D'" style="margin-left: 6px;height:calc(100vh - 200px);"
                      :body-style="{'padding':'0px'}">
                <examined-outpatient/>
              </a-card>
            </a-card>
          </a-col>
          <a-col :xxl="2" :xl="2" :lg="2" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
        </a-row>
      </a-layout-content>
      <a-layout-footer style="padding: 0px!important;">
        <gpws-footer/>
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import GpwsHeader from '@/components/base/Header.vue';
import GpwsFooter from '@/components/base/Footer.vue';
import ReserveOutpatient from '@/components/telemed/expert/ReserveOutpatient.vue';
import ExamineOutpatient from '@/components/telemed/examine/ExamineOutpatient.vue';
import TelemedOutpatient from '@/components/telemed/expert/TelemedOutpatient.vue';
import ExaminedOutpatient from '@/components/telemed/examine/ExaminedOutpatient.vue';

export default {
  name: "ExpertTelemed",
  components: {
    GpwsHeader,
    GpwsFooter,
    ReserveOutpatient,
    ExamineOutpatient,
    TelemedOutpatient,
    ExaminedOutpatient
  },
  data() {
    return {
      current: {},
      init: {
        business: 'A'
      }
    }
  },
  mounted() {
    this.$store.commit('updateTopMenu', '205');
  },
  methods: {
    businessChecked: function (business) {
      if(business != 'A' && this.$refs.reserve){
        this.$refs.reserve.clearTimeHandler();
      }
      this.init.business = business;
    },
    refreshAction:function (){
      this.$refs.reserve.refreshAction();
    }
  }
}
</script>

<style scoped>
.gpws-business-left-active {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
  color: white;
}

.gpws-business-right-active {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
  color: white;
}

.gpws-business-left-btn {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
}

.gpws-business-right-btn {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
}

.gpws-business-active {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  color: white;
}

.gpws-business-btn {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
}
</style>
